import * as logger from 'loglevel';
import axiosWrapper from '../../helpers/axiosWrapper';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';

/**
 * Makes sure the travels response is complain with a basic schema
 * @param {*} travels
 */
const validateTravelsResponse = (travelResponseRaw) => {
  const validation = { isValid: true, message: '' };
  if (!travelResponseRaw || !Array.isArray(travelResponseRaw)) {
    return {
      isValid: false,
      message:
        'INTEGRATION__TRAVELS_GUIDE: TravelsGuide SCHEMA is invalid, please check TravelsGuide API documentation.'
    };
  }
  if (
    travelResponseRaw.length > 0 &&
    (!travelResponseRaw[0]?.content?.sections ||
      !travelResponseRaw[1]?.content ||
      !travelResponseRaw[2]?.content)
  ) {
    return {
      isValid: false,
      message:
        'INTEGRATION__TRAVELS_GUIDE: TravelsGuide SCHEMA is invalid, please check TravelsGuide API documentation.'
    };
  }
  return validation;
};

/**
 * This function format the title
 * @param {*} title
 */
const getTitle = (title) => title.charAt(0).toUpperCase() + title.slice(1);

/**
 * This function return the items for a section
 * @param {*} section
 */
const getItemsForSection = (section, rawData) => {
  let item;
  const listItems = [];
  for (let itemId in rawData[1].content) {
    if (section?.items.includes(itemId)) {
      item = rawData[1].content[itemId];
      const images_path = getImagesPath(rawData[0]?.images_path, item.media);
      listItems.push({ ...item, images_path });
    }
  }
  return listItems;
};

/**
 * This function return the images paths for a section
 * @param {*} section
 */
const getImagesPath = (image_path, item, avoidTypeCheck = false) => {
  // eslint-disable-next-line array-callback-return
  return item.map((media) => {
    if (!avoidTypeCheck) {
      if (media.type === 'image') {
        return `${image_path}${media.name}`;
      }
    } else {
      return `${image_path}${media}`;
    }
  });
};

/**
 * This function return ids and attribute name for articles
 * @param {*} map articles
 */
const getArticlesMap = (articles_map) => {
  const data = {
    article1: {
      ids: []
    },
    article2: {
      ids: []
    }
  };
  let tmp;
  if (articles_map['article_1-1'] && articles_map['article_1-1'] !== '') {
    tmp = articles_map['article_1-1'].split('$*');
    if (tmp[0] === 'article2') {
      data.article2.ids.push(tmp[1]);
    }
    if (tmp[0] === 'article1') {
      data.article1.ids.push(tmp[1]);
    }
  }
  if (articles_map['article_1-2'] && articles_map['article_1-2'] !== '') {
    tmp = articles_map['article_1-2'].split('$*');
    if (tmp[0] === 'article2') {
      data.article2.ids.push(tmp[1]);
    }
    if (tmp[0] === 'article1') {
      data.article1.ids.push(tmp[1]);
    }
  }
  if (articles_map['article_2-1'] && articles_map['article_2-1'] !== '') {
    tmp = articles_map['article_2-1'].split('$*');
    if (tmp[0] === 'article2') {
      data.article2.ids.push(tmp[1]);
    }
    if (tmp[0] === 'article1') {
      data.article1.ids.push(tmp[1]);
    }
  }
  if (articles_map['article_2-2'] && articles_map['article_2-2'] !== '') {
    tmp = articles_map['article_2-2'].split('$*');
    if (tmp[0] === 'article2') {
      data.article2.ids.push(tmp[1]);
    } else {
      data.article1.ids.push(tmp[1]);
    }
  }
  return data;
};

/**
 * The <name> API returns the data in non linear format
 * so this function will intend normalize the data for the components
 * @param {*} travelsRawData
 */
export const transformData = (travelsRawData) => {
  const json_base_location = travelsRawData;
  let travels = {};
  let sections = [];
  let articles = [];
  let section;
  let items;

  if (travelsRawData.length === 0) {
    return travels;
  }

  const json_sections_location = json_base_location[0]?.content?.sections;
  for (let section_name in json_sections_location) {
    section = json_sections_location[section_name];
    if (section_name !== 'landmarks') {
      items = getItemsForSection(section, json_base_location);
      section = {
        ...section,
        items,
        images_path: getImagesPath(json_base_location[0].images_path, section.media)
      };
      sections.push(section);
    }
  }
  const json_articles_location = json_base_location[2].content.entry;
  const [part1, part2] = json_articles_location.split('$*');
  const articles_object_map = json_base_location[2].content.pxdata[part1][part2];
  const articles_map = getArticlesMap(articles_object_map);
  for (let article_ in articles_map) {
    let index = 0;
    articles_map[article_].ids.forEach((item) => {
      if (articles_map[article_].ids.length !== 0) {
        const tmp = json_base_location[2].content.pxdata[article_][item];
        if (index < 2) {
          articles.push({
            ...tmp,
            images_path: getImagesPath(json_base_location[2].images_path, tmp.article2Slides, true)
          });
        }
        index++;
      }
    });
  }
  travels.title = getTitle(json_base_location[0]?.content?.iso);
  travels.sections = sections;
  travels.articles = articles;
  return travels;
};

/**
 * Retrieve language name from iso Language
 * @param {*} integrationSettings
 */
const getLanguageName = (isoLanguage, languageMap) => {
  const index = languageMap.findIndex((item) => item.isoCode === isoLanguage);
  return index === -1 ? '' : languageMap[index];
};

const getGeoId = (url) => {
  const url_parts = url.split('/');
  return url_parts[url_parts.length - 2];
};

/**
 * Return the update url include language name
 * @param {*} integrationSettings
 */
const updateUrl = (url, language) => {
  let newUrl = url;
  let index = -1;
  for (let i = 0; i < 2; i++) {
    index = newUrl.lastIndexOf('/');
    if (index !== -1) {
      newUrl = newUrl.substring(0, index);
    }
  }
  return newUrl;
};

/**
 * Retrieve travels from the Json ->  <name> Endpoint
 * @param {*} integrationSettings
 */
const getTravelsGuide = (
  prePopulation,
  integrationSettings,
  meta = 'meta',
  pageContext = undefined
) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__TRAVELSGUIDE: **integrationSettings** not specified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { v1TravelsGuide: travelsApiSettings } = integrationSettings;
    const { cache = false, cacheDuration = NO_DURATION_DEFINED } = travelsApiSettings;
    if (
      !travelsApiSettings ||
      !travelsApiSettings.method ||
      !travelsApiSettings.endPoint ||
      !travelsApiSettings.auth
    ) {
      const MESSAGE = `INTEGRATION__TRAVELSGUIDE: **integrationSettings.travelsGuide** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    const { language, languageMap } = prePopulation;
    const languageName = getLanguageName(language, languageMap);
    const geoId = getGeoId(travelsApiSettings.endPoint);
    const newUrl = updateUrl(travelsApiSettings.endPoint, languageName);
    let params = new URLSearchParams({
      geoId,
      language: languageName.language,
      apiKey: travelsApiSettings.headers['EM-API-Key']
    });

    axiosWrapper(
      {
        method: travelsApiSettings.method,
        url: `${newUrl}?${params.toString()}`,
        headers: {}
      },
      {
        resource: 'INTEGRATION__TRAVELS_GUIDE',
        meta,
        integrationSettings,
        pageContext,
        cache,
        cacheDuration
      }
    )
      .then((resp) => {
        const validation = validateTravelsResponse(resp.data);
        if (validation.isValid) {
          logger.info('INTEGRATION__FARES: Successful request', resp.data);
          const fares = transformData(resp.data);
          resolve(fares);
        } else {
          logger.error(validation.message, validation.data);
          reject(resp.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { getTravelsGuide };
